import(/* webpackMode: "eager" */ "/app/src/app/mvp/layout.js");
